import { useMemo } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import StyledLink from './StyledLink';

interface IProps<S> extends LinkProps<S> {
  condition: unknown;
  styled?: boolean;
}

/**
 * A link that points to nothing if the given condition is false.
 */
const ConditionalLink = <S,>(props: IProps<S>) => {
  const { condition, styled, children, ...linkProps } = props;

  const LinkComponent = useMemo(() => (styled ? StyledLink : Link), [styled]);

  return condition ? (
    <LinkComponent {...linkProps}>{children}</LinkComponent>
  ) : (
    <div className={props.className} style={props.style}>
      {children}
    </div>
  );
};

export default ConditionalLink;
